import React, { useEffect, useState } from 'react';
import {Link} from 'react-router-dom';
import ApiService from '../../../../services/api';
import '../../css/admin_dashboard.css';

import User from '../../../../media/user.png';
import Course from '../../../../media/courses_white.png';
import Organization from '../../../../media/organization.png';
import Category from '../../../../media/category.png';
import Teacher from '../../../../media/teacher.png';

import useSlotCountUp from '../../../../services/slot';

const Dashboard = () => {
  const [coursesCount, setCoursesCount] = useState(0);
  const [usersCount, setUsersCount] = useState(0);
  const [organizationsCount, setOrganizationsCount] = useState(0);
  const [categoriesCount, setCategoriesCount] = useState(0);
  const [teacherCount, setTeacherCount] = useState(0);

  const fetchCategories = async () => {
    try {
      const data = await ApiService.getCategories();
      setCategoriesCount(data.length);
    } catch (error) {
      console.error('Errore caricamento categorie', error);
    }
  };

  const fetchTeachers = async () => {
    try {
      const data = await ApiService.getTeachers();
      setTeacherCount(data.length);
    } catch (error) {
      console.error('Errore caricamento insegnanti', error);
    }
  };

  const fetchCourses = async () => {
    try {
      const data = await ApiService.getCourses();
      setCoursesCount(data.length);
    } catch (error) {
      console.error('Errore caricamento corsi', error);
    }
  };

  const fetchUsers = async () => {
    try {
      const data = await ApiService.getUsers();
      setUsersCount(data.length);
    } catch (error) {
      console.error('Errore caricamento utenti', error);
    }
  };

  const fetchOrganizations = async () => {
    try {
      const data = await ApiService.getOrganizations();
      setOrganizationsCount(data.length);
    } catch (error) {
      console.error('Errore caricamento enti', error);
    }
  };

  useEffect(() => {
    fetchCourses();
    fetchUsers();
    fetchOrganizations();
    fetchCategories();
    fetchTeachers();
  }, []);

  
  const cat = useSlotCountUp(categoriesCount);
  const teach = useSlotCountUp(teacherCount);
  const course = useSlotCountUp(coursesCount);
  const user = useSlotCountUp(usersCount);
  const org = useSlotCountUp(organizationsCount);

  return (
    <div>
      <h1>Dashboard</h1>

      <div className="dashboard-grid">
        <Link to="/admin/categorie" className='menu-link'>
          <div className="dash-card">
            <div className="dash-card-content">
              <h3>
                <img src={Category} alt="categorie" className="section-image" />
                Categorie <span>{cat}</span>
              </h3>
            </div>
          </div>
        </Link>

        <Link to="/admin/insegnanti" className='menu-link'>
          <div className="dash-card">
            <div className="dash-card-content">
              <h3>
                <img src={Teacher} alt="insegnanti" className="section-image" />
                Insegnanti <span>{teach}</span>
              </h3>
            </div>
          </div>
        </Link>

        <Link to="/admin/corsi" className='menu-link'>
          <div className="dash-card">
            <div className="dash-card-content">
              <h3>
                <img src={Course} alt="corsi" className="section-image" />
                Corsi <span>{course}</span>
              </h3>
            </div>
          </div>
        </Link>

        <Link to="/admin/utenti" className='menu-link'>
        <div className="dash-card">
          <div className="dash-card-content">
            <h3>
              <img src={User} alt="utenti" className="section-image" />
              Utenti <span>{user}</span>
            </h3>
          </div>
        </div>
        </Link>

        <Link to="/admin/enti" className='menu-link'>
          <div className="dash-card last-card">
            <div className="dash-card-content">
              <h3>
                <img src={Organization} alt="enti" className="section-image" />
                Enti <span>{org}</span>
              </h3>
            </div>
          </div>
        </Link>

      </div>
    </div>
  );
};

export default Dashboard;